import { ShopSlider } from '../search'
import { target } from 'utils'
import {
  setOperatorIconClass,
  getOperatorTypeTitle,
} from '../popups/GroupBookingPopup'
import { DateFormat, PriceConverter } from '../helpers'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import isNull from 'lodash/isNull'

const TripLanguages = ({ languages }) => {
  return (
    <span>
      {languages.map((language) => language.title).join(', ')}{' '}
      <FormattedMessage
        id='trip_language'
        defaultMessage='{ qty, plural, one {(trip language)} other {(trip languages)} }'
        values={{
          qty: languages.length,
        }}
      />
    </span>
  )
}

export default function GroupTripCard({ trip }) {
  const handleClick = (e) => {
    e.stopPropagation()
    window.open(trip.url, target)
  }
  return (
    <div
      key={trip.url}
      className={`boat search-page-item-card ${
        trip.isHighlighted ? 'highlighted' : ''
      }`}
    >
      <div className='boat-info'>
        <div className='photo-slider'>
          <ShopSlider
            apiUrl={trip.imageApiUrl}
            shopUrl={trip.url}
            slug={trip.slug}
            background={trip.background.FeaturedDealsBigTabletLand}
          />
        </div>
        <div className='shop-info' onClick={handleClick}>
          <div className='shop-head'>
            <a className='shop-title' target={target} href={trip.url}>
              <span>{trip.title}</span>
            </a>
          </div>
          <div className='shop-desc group-trip-description'>
            <div className='shop-desc-text'>
              <ul className='group-trip-info'>
                <li>
                  <i
                    className={`font-icons ${setOperatorIconClass(
                      trip.operatorType
                    )}`}
                  />
                  {getOperatorTypeTitle(trip.operatorType)}
                </li>
                <li>
                  <i className='font-icons location-icon' />
                  {trip.countryTitle}
                </li>
                <li>
                  <i className='font-icons calendar-icon' />
                  <DateFormat
                    date={trip.dateStart}
                    format={
                      trip.dateStart.substr(0, 4) === trip.dateEnd.substr(0, 4)
                        ? 'DD MMM'
                        : 'DD MMM YYYY'
                    }
                  />{' '}
                  - <DateFormat date={trip.dateEnd} format='DD MMM YYYY' />,
                  <FormattedMessage
                    id='night_trip_card_qty'
                    values={{
                      qty: moment(trip.dateEnd).diff(trip.dateStart, 'd'),
                    }}
                    defaultMessage='{qty, plural, one {# night} other {# nights}}'
                  />
                </li>
                <li>
                  <i className='font-icons peoples-icon' />
                  {trip.groupSizeMax === trip.groupSizeMin ? (
                    <FormattedMessage
                      id='people_group_same'
                      values={{
                        max: trip.groupSizeMax,
                      }}
                      defaultMessage='{max} people group'
                    />
                  ) : (
                    <FormattedMessage
                      id='people_group'
                      values={{
                        min: trip.groupSizeMin,
                        max: trip.groupSizeMax,
                      }}
                      defaultMessage='{min} - {max} people group'
                    />
                  )}
                </li>
                {trip.languages && !!trip.languages.length && (
                  <li>
                    <i className='font-icons chat-icon' />
                    <TripLanguages languages={trip.languages} />
                  </li>
                )}
              </ul>
              {trip.organiser && (
                <div className='operator-teaser'>
                  <div className='operator-teaser__image'>
                    <img src={trip.organiser.background.ExtranetPreview} />
                  </div>
                  <div className='operator-teaser__info-wrapper'>
                    <p className='operator-teaser__title bold'>
                      {trip.organiser.title}
                    </p>
                    <p className='operator-teaser__info'>
                      {trip.organiser.formattedAddress}
                    </p>
                    {trip.organiser.tripAdvisor && (
                      <div className='rating-wrap tripadvisor'>
                        <div className='tripadvisor-rating-wrap'>
                          <img
                            src={trip.organiser.tripAdvisor.ratingImageUrl}
                          />
                          <span className='rating-count'>
                            <a
                              href={trip.organiser.tripAdvisor.webUrl}
                              target='_blank'
                            >
                              {trip.organiser.tripAdvisor.numReviews}{' '}
                              <FormattedMessage
                                id='reviews'
                                defaultMessage='Reviews'
                              />
                            </a>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className='prices'>
              {!!trip.price && (trip.itemsLeft > 0 || isNull(trip.itemsLeft)) && (
                <div className='price'>
                  <p className='cur-price'>
                    <small>
                      <FormattedMessage id='from' defaultMessage='From' />
                    </small>
                    <strong>
                      <PriceConverter
                        amount={trip.price.value}
                        currency={trip.price.currency}
                      />
                    </strong>
                  </p>
                  <p className='price-info'>
                    <FormattedMessage
                      id='per_person'
                      defaultMessage='per person'
                    />
                  </p>
                  {trip.itemsLeft !== null && trip.itemsLeft <= 4 && (
                    <span className='spots-number'>
                      <FormattedMessage
                        id='spots_left'
                        values={{
                          qty: trip.itemsLeft,
                        }}
                        defaultMessage='Only { qty, plural, one {# spot } other {# spots } } left'
                      />
                    </span>
                  )}
                </div>
              )}

              {trip.itemsLeft === 0 && (
                <span className='sold-out-group'>
                  <i className='font-icons fail-icon-new' />
                  &nbsp;
                  <FormattedMessage id='sold_out' defaultMessage='Sold out' />
                </span>
              )}
              <button className='btn-red'>
                <FormattedMessage id='view_trip' defaultMessage='View trip' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
